import React from 'react';
import { colors } from '@styleseat/brand';

type BasicThumbsDownIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const BasicThumbsDownIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
}: BasicThumbsDownIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.137 15.5579C16.0609 15.3574 15.9826 15.1509 15.9548 15.0757L15.927 15H19C20.8696 15 22 13.6825 22 12C22 6.05643 20.7551 2 18 2C18 2 11.0231 2.00023 10.9989 1.99972C10.3408 1.98791 9.50544 2.08045 8.66312 2.38182C8.29505 2.51352 7.95642 2.67737 7.65294 2.87371C7.29284 2.34624 6.68686 2 6 2H4C2.89543 2 2 2.89543 2 4V13C2 14.1046 2.89543 15 4 15H6C6.19836 15 6.38997 14.9711 6.57086 14.9173C7.26776 15.9321 9.03061 17.9465 10.447 19.565C11.215 20.4426 11.8811 21.2038 12.2203 21.6261L12.5205 22H13.0077C13.6148 22.0001 14.1423 21.954 14.7483 21.7775C16.0919 21.3863 17 20.472 17 19C17 18.4799 16.9079 17.9254 16.7382 17.3099C16.626 16.9026 16.4872 16.4914 16.2971 15.9811C16.2699 15.9081 16.2043 15.7353 16.137 15.5579ZM8 13V6C8 5.09777 8.45197 4.58153 9.33688 4.26492C9.91062 4.05964 10.5254 3.99155 10.9656 3.99941L16.5338 3.99999L18 4C19.0151 4 20 7.20926 20 12C20 12.6401 19.6912 13 19 13H15C13.8055 13 13.5555 13.9237 13.8047 14.9237C13.8633 15.1589 13.9489 15.4178 14.079 15.7695C14.1101 15.8538 14.1944 16.0759 14.273 16.2831L14.2732 16.2834L14.2733 16.2837L14.2733 16.2837C14.3378 16.4539 14.3986 16.614 14.4229 16.6793C14.5944 17.1396 14.7161 17.5004 14.8101 17.8414C14.9359 18.2977 15 18.6834 15 19C15 19.451 14.7622 19.6904 14.1891 19.8573C13.9484 19.9274 13.7114 19.966 13.46 19.9849C12.9338 19.3559 12.1803 18.4962 11.4047 17.6113C9.90194 15.8969 8.31645 14.088 8.14171 13.68C8.04443 13.4529 8 13.2402 8 13ZM4 13V4H6V13H4Z"
      fill={color}
    />
  </svg>
);
